import { useEffect, useRef, useState } from 'react';
import { useUpdateSurveyMutation } from 'state';
import { useDebouncedValue } from 'hooks';
import { MUST_PICK_CM_MIN, MUST_PICK_CM_MAX } from '../../fields.constants';

const SAVE_DELAY_MS = 500;

export const useMustPickCm = ({ fieldId, surveyId, mustPickCm }) => {
  const [updateSurvey] = useUpdateSurveyMutation();
  const [text, setText] = useState(String(mustPickCm));
  const [saveError, setSaveError] = useState(false);
  const isMounted = useRef(true);

  const value = Number(text);
  const isValid =
    text.trim() !== '' && value >= MUST_PICK_CM_MIN && value <= MUST_PICK_CM_MAX;
  const debounced = useDebouncedValue(isValid ? value : null, SAVE_DELAY_MS);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    []
  );

  useEffect(() => {
    if (debounced === null || debounced === mustPickCm) return;
    setSaveError(false);
    updateSurvey({ fieldId, surveyId, mustPickCm: debounced }).then(result => {
      if (!result.error || !isMounted.current) return;
      setSaveError(true);
      setText(String(mustPickCm));
    });
  }, [debounced]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    text,
    isValid,
    isSaving: isValid && value !== mustPickCm,
    shownCm: isValid ? value : mustPickCm,
    saveError,
    onChange: event => setText(event.target.value),
    onBlur: () => {
      if (!isValid) setText(String(mustPickCm));
    }
  };
};
